import React from "react";
import { Container } from "@mui/material";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <>
      <header className="header">
        <Container>
          <div className="change-lang">
            <Link to="/">
              <button className="change-lang-btn">English</button>
            </Link>
            <Link to="/ukr">
              <button className="change-lang-btn lang-ukr">Українська</button>
            </Link>
          </div>
        </Container>
      </header>
    </>
  );
};

export default Header;
